var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.16 148.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fe8f30;\n      }\n\n      .cls-2 {\n        fill: #0a4aaf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.84,118.85h-5.24c-1.78,0-3.23-1.44-3.23-3.23v-43.08h5.24c1.78,0,3.23,1.44,3.23,3.23v43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69,118.85h-5.24c-1.78,0-3.23-1.44-3.23-3.23v-43.08h5.24c1.78,0,3.23,1.44,3.23,3.23v43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.16,118.85h-5.24c-1.78,0-3.23-1.44-3.23-3.23v-43.08h5.24c1.78,0,3.23,1.44,3.23,3.23v43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.32,118.85h-5.24c-1.78,0-3.23-1.44-3.23-3.23v-43.08h5.24c1.78,0,3.23,1.44,3.23,3.23v43.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.16,59.84l-40.34-28.3-3.14-2.2c-1.03-.72-2.41-.72-3.44,0l-3.14,2.2L28.39,62.21v6.98c0,1.41,1.59,2.24,2.75,1.43l44.34-31.11c.89-.63,2.08-.63,2.97,0l38.85,27.26v40.54L28.39,82.19v6.69c0,1.25,.83,2.34,2.03,2.68l84.57,23.9,7.01,1.98c1.88,.53,3.75-.88,3.75-2.84V63.78c0-.88-.43-1.71-1.15-2.22l-2.45-1.72Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.623acc4e1f5b0d95ab4bc9765693727e.svg";
export { ForwardRef as ReactComponent };